import alt from 'components/Dispatcher';
import generateAsyncActions from 'utils/generateAsyncActions';
import ArchivingProfileSource from 'sources/ArchivingProfileSource';

class ArchivingProfileActions {
  constructor() {
    this.generateActions(
      ...generateAsyncActions('fetchArchivingProfiles'),
      'saveSuccess',
      'saveError'
    );
  }
  fetchArchivingProfiles() {
    return dispatch => {
      dispatch();
      return ArchivingProfileSource.fetchArchivingProfiles().then(
        this.fetchArchivingProfilesSuccess,
        this.fetchArchivingProfilesError
      );
    };
  }

  sendCreateRequest(profile, shouldOverwrite) {
    return dispatch => {
      dispatch(profile);
      this.fetchArchivingProfilesLoading();
      return ArchivingProfileSource.create(profile, shouldOverwrite).then(
        profiles => {
          this.saveSuccess();
          return this.fetchArchivingProfilesSuccess(profiles);
        },
        error => {
          this.saveError(error);
          this.fetchArchivingProfilesError();
          throw error;
        }
      );
    };
  }
  sendUpdateRequest(profile, shouldOverwrite) {
    return dispatch => {
      dispatch(profile);
      this.fetchArchivingProfilesLoading();
      return ArchivingProfileSource.update(profile, shouldOverwrite).then(
        profiles => {
          this.saveSuccess();
          return this.fetchArchivingProfilesSuccess(profiles);
        },
        error => {
          this.saveError(error);
          throw error;
        }
      );
    };
  }
}

export default alt.createActions(ArchivingProfileActions);
